import * as React from "react";
import * as ReactDOM from "react-dom";

import * as VCResources from "VersionControl/Scripts/Resources/TFS.Resources.VersionControl";
import * as CustomerIntelligenceConstants from "VersionControl/Scripts/CustomerIntelligenceConstants";

import { FilterHelpers } from "Presentation/Scripts/TFS/Controls/Filters/FilterHelpers";
import { FilterPanelToggleButton } from "Presentation/Scripts/TFS/Controls/Filters/FilterPanelToggleButton";
import { FilterState } from "Presentation/Scripts/TFS/Controls/Filters/IFilterPanel";
import { PullRequestListActionCreator } from "VersionControl/Scenarios/PullRequestList/Actions/PullRequestListActionCreator";
import { StoresHub } from "VersionControl/Scenarios/PullRequestList/Stores/StoresHub";
import { TfsContext } from "Presentation/Scripts/TFS/TFS.Host.TfsContext";
import { GitRepositoryContext } from "VersionControl/Scripts/GitRepositoryContext";

import { PrimaryButton } from "OfficeFabric/Button";
import { PullRequestListFilter, PullRequestFilterSearchCriteria } from "VersionControl/Scenarios/PullRequestList/PullRequestListFilter";
import { PullRequestListSearchBox } from "VersionControl/Scenarios/PullRequestList/PullRequestListSearchBox";

import { CodeHubContributionIds } from "VersionControl/Scripts/CodeHubContributionIds";
import { onClickNavigationHandler } from "VersionControl/Scripts/Utils/XhrNavigationUtils";

import "VSS/LoaderPlugins/Css!VersionControl/PullRequestListTitle";

export interface PullRequestListTitleProps {
    repositoryContext: GitRepositoryContext;
    storesHub: StoresHub;
    actionCreators: PullRequestListActionCreator;
    tfsContext: TfsContext;
    initialSearchCriteria: PullRequestFilterSearchCriteria;
    hasPermissionToCreatePullRequest: boolean;
    viewMyBranches: boolean;
    onSearchCriteriaUpdated(searchCriteria?: PullRequestFilterSearchCriteria): void;
    pickerEnabled: boolean;
    isFilterBarVisible: boolean;
}

export class PullRequestListTitle extends React.Component<PullRequestListTitleProps, {}> {
    public static attach(element: HTMLElement, props: PullRequestListTitleProps): React.Component<any, {}> {
        return ReactDOM.render<any>(<PullRequestListTitle {...props} />, element) as React.Component<any, {}>;
    }

    public render(): JSX.Element {
        const filterSearchCriteria = $.extend({}, this.props.initialSearchCriteria);
        const filterUpdatedCallback = (searchCriteria: PullRequestFilterSearchCriteria) => this.props.onSearchCriteriaUpdated(searchCriteria);

        return <div className="vc-pullrequest-list-titleArea">
            <div className="flex flex-noshrink">
                <h1 className="page-title flex-grow">{VCResources.PullRequest_HubName}</h1>
                <div className="vc-pullrequest-filtered-list-right flex flex-noshrink">
                    {
                        this.props.pickerEnabled &&
                        <FilterPanelToggleButton
                            isFilterPanelVisible={this.props.isFilterBarVisible}
                            filterState={FilterHelpers.hasNonEmptyProperties(filterSearchCriteria) ? FilterState.FILTER_APPLIED : FilterState.FILTER_CLEARED}
                            toggleFilterPanel={() => this.props.actionCreators.toggleFilterBar(!this.props.isFilterBarVisible)}
                        />
                    }
                    <PullRequestListSearchBox storesHub={this.props.storesHub} actionCreator={this.props.actionCreators} tfsContext={this.props.tfsContext} />
                    <div className="new-pr-button-container">
                        {this.props.hasPermissionToCreatePullRequest &&
                            <PrimaryButton className="vc-pullrequest-list-new-button"
                                onClick={this.onNewPullRequestClick}
                                href={this.props.storesHub.pullRequestListStore.getNewPullRequestUrl()}>
                                {VCResources.PullRequest_CreatePullRequestButtonCaption}
                            </PrimaryButton>
                        }
                    </div>
                </div>
            </div>
            {
                <PullRequestListFilter
                    initialSearchCriteria={filterSearchCriteria}
                    filterUpdatedCallback={filterUpdatedCallback}
                    repositoryContext={this.props.repositoryContext}
                    mruAuthors={[]}
                    isVisible={this.props.pickerEnabled && this.props.isFilterBarVisible}
                    viewMyBranches={this.props.viewMyBranches}
                />
            }
        </div>;
    }

    private onNewPullRequestClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        this.props.actionCreators.onNavigateToNewPullRequest(CustomerIntelligenceConstants.PULL_REQUEST_CREATE_SOURCEUI_TOOLBAR);
        onClickNavigationHandler(event, CodeHubContributionIds.pullRequestHub, (event.currentTarget as HTMLAnchorElement).href);
    }
}
